import type { MomentsSavedHighlight } from '@/store/api/momentsApi';

const noteDateFormatter = new Intl.DateTimeFormat('en-US', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

export const getSavedHighlightPath = (
  highlight: MomentsSavedHighlight,
): string => {
  if (!highlight.artifact || highlight.sourceIdentity) {
    return `/m/highlights?view=owned-snapshots&noteId=${encodeURIComponent(highlight.id)}`;
  }
  const dateSlug = highlight.artifact.routeDateSlug || 'reflection';
  return `/m/artifacts/session-reflection/${highlight.artifactId}/${dateSlug}#${highlight.id}`;
};

export const formatSavedHighlightDate = (value: string | undefined): string => {
  if (!value) {
    return '';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return noteDateFormatter.format(date);
};
